import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [status, setStatus] = useState(''); // '', submitting, success, error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setStatus('error');
      setMessage('Passwords do not match.');
      return;
    }
    
    if (password.length < 6) {
      setStatus('error');
      setMessage('Password must be at least 6 characters.');
      return;
    }

    if (!/[a-zA-Z]/.test(password) || !/\d/.test(password)) {
      setStatus('error');
      setMessage('Password must contain at least one letter and one number.');
      return;
    }

    try {
      setStatus('submitting');
      const response = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await response.json();
      
      if (data.success) {
        setStatus('success');
        setMessage(data.message);
      } else {
        setStatus('error');
        setMessage(data.message || 'Reset failed');
      }
    } catch (err) {
      setStatus('error');
      setMessage('Network error. Please try again.');
    }
  };

  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0d47a1 0%, #1a73e8 50%, #42a5f5 100%)',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    padding: '20px'
  };

  const cardStyle = {
    background: '#fff',
    borderRadius: '16px',
    padding: '48px 40px',
    maxWidth: '440px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
  };

  const inputStyle = {
    width: '100%', padding: '14px', borderRadius: '8px',
    border: '1px solid #ddd', fontSize: '15px', boxSizing: 'border-box',
    marginBottom: '16px'
  };

  if (!token) {
    return (
      <div style={containerStyle}>
        <div style={{ ...cardStyle, textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <h2 style={{ color: '#c62828' }}>Invalid Reset Link</h2>
          <p style={{ color: '#666', marginBottom: '24px' }}>
            This password reset link is invalid or has been used.
          </p>
          <a href="/forgot-password" style={{ color: '#1a73e8', textDecoration: 'none' }}>
            Request a new reset link →
          </a>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div style={containerStyle}>
        <div style={{ ...cardStyle, textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
          <h2 style={{ color: '#2e7d32', marginBottom: '12px' }}>Password Reset!</h2>
          <p style={{ color: '#666', marginBottom: '24px' }}>{message}</p>
          <a 
            href="/login"
            style={{
              display: 'inline-block', background: '#1a73e8', color: '#fff',
              padding: '12px 32px', borderRadius: '8px', textDecoration: 'none',
              fontWeight: '600'
            }}
          >
            Go to Login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>🔑</div>
          <h2 style={{ color: '#1a1a1a', marginBottom: '8px' }}>Create New Password</h2>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Enter your new password below.
          </p>
        </div>

        <div style={{ position: 'relative' }}>
          <input
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="New password"
            style={inputStyle}
            minLength="6"
          />
        </div>

        <input
          type={showPassword ? 'text' : 'password'}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm new password"
          style={inputStyle}
        />

        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', cursor: 'pointer' }}>
          <input 
            type="checkbox" 
            checked={showPassword} 
            onChange={() => setShowPassword(!showPassword)} 
          />
          <span style={{ color: '#666', fontSize: '13px' }}>Show passwords</span>
        </label>

        <p style={{ color: '#888', fontSize: '12px', marginBottom: '16px' }}>
          Password must be at least 6 characters with at least one letter and one number.
        </p>

        {status === 'error' && (
          <p style={{ color: '#c62828', fontSize: '13px', marginBottom: '12px' }}>{message}</p>
        )}

        <button
          onClick={handleSubmit}
          disabled={status === 'submitting' || !password || !confirmPassword}
          style={{
            width: '100%', padding: '14px', borderRadius: '8px',
            background: '#1a73e8', color: '#fff', border: 'none',
            fontSize: '15px', fontWeight: '600', cursor: 'pointer',
            opacity: (status === 'submitting' || !password || !confirmPassword) ? 0.6 : 1
          }}
        >
          {status === 'submitting' ? 'Resetting...' : 'Reset Password'}
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
